import React from 'react';
import { useNavigate } from 'react-router';
import { BookOpen, Calendar, MessageCircle, Heart, HelpCircle, Settings } from 'lucide-react';

const IntroCard = ({ icon: Icon, title, description, to, color, onClick }) => {
    return (
        <div className="intro-card-link" onClick={onClick}>
            <div className="intro-card" style={{ borderTop: `4px solid ${color}` }}>
                <div className="intro-card-icon" style={{ color }}>
                    <Icon size={36} />
                </div>
                <h2 className="intro-card-title">{title}</h2>
                <p className="intro-card-description">{description}</p>
            </div>
        </div>
    );
};

const IntroScreen = () => {
    const navigate = useNavigate();

    const cards = [
        {
            icon: BookOpen,
            title: "Daily Prayer",
            description: "Access your daily prayer guide with scripture and reflections",
            to: "/prayers",
            color: "var(--color-primary)"
        },
        {
            icon: Calendar,
            title: "Calendar",
            description: "View and plan your prayer schedule for the month",
            to: "/calendar",
            color: "var(--color-secondary)"
        },
        {
            icon: MessageCircle,
            title: "Journal",
            description: "Record your thoughts and reflections on your prayer journey",
            to: "/journal",
            color: "#f59e0b" // warning color
        },
        {
            icon: Heart,
            title: "Prayer Requests",
            description: "Keep track of prayer requests for yourself and others",
            to: "/requests",
            color: "#ef4444" // error color
        },
        {
            icon: HelpCircle,
            title: "Resources",
            description: "Discover helpful resources to deepen your prayer life",
            to: "/resources",
            color: "#8b5cf6" // purple
        },
        {
            icon: Settings,
            title: "Settings",
            description: "Customize your prayer guide experience",
            to: "/settings",
            color: "#6b7280" // text-light color
        }
    ];

    return (
        <div className="intro-screen">
            <div className="intro-header">
                <h1 className="text-center font-bold text-primary mb-2">Prayer Guide</h1>
                <p className="text-center text-muted mb-8">Your companion for daily prayer and reflection</p>
            </div>

            <div className="intro-grid">
                {cards.map((card, index) => (
                    <IntroCard
                        key={index}
                        {...card}
                        onClick={() => navigate(card.to)}
                    />
                ))}
            </div>
        </div>
    );
};

export default IntroScreen;
